import { useState, useEffect } from 'react';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 768 : false
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 767px)');
    const onChange = (e) => setIsMobile(e.matches);
    mq.addEventListener('change', onChange);
    setIsMobile(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isMobile;
}

export function useIsTablet() {
  const [isTablet, setIsTablet] = useState(
    typeof window !== 'undefined'
      ? window.innerWidth >= 768 && window.innerWidth < 1024
      : false
  );
  useEffect(() => {
    const onResize = () =>
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 1024);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);
  return isTablet;
}

export function useIsCompact() {
  const [isCompact, setIsCompact] = useState(
    typeof window !== 'undefined' ? window.innerWidth < 1024 : false
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1023px)');
    const onChange = (e) => setIsCompact(e.matches);
    mq.addEventListener('change', onChange);
    setIsCompact(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isCompact;
}

// Breakpoint du chat « Le Cabinet » : sous 1180px le rail gauche et l'aside
// droit passent en tiroirs (cf. @media dans AgentChatView), donc la grille
// centrale doit repasser à une seule colonne au MÊME point de bascule.
export function useIsCabCompact() {
  const [isCabCompact, setIsCabCompact] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 1180 : false
  );
  useEffect(() => {
    const mq = window.matchMedia('(max-width: 1180px)');
    const onChange = (e) => setIsCabCompact(e.matches);
    mq.addEventListener('change', onChange);
    setIsCabCompact(mq.matches);
    return () => mq.removeEventListener('change', onChange);
  }, []);
  return isCabCompact;
}
